import { useState } from "react";
import { isInAppBrowser, buildSafariUrl, buildChromeIntent } from "@/lib/inAppBrowser";

export const InAppBrowserBanner = (): JSX.Element | null => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !isInAppBrowser()) return null;

  const currentUrl = window.location.href;
  const isIos = /iPhone|iPad|iPod/.test(navigator.userAgent);
  const target = isIos ? buildSafariUrl(currentUrl) : buildChromeIntent(currentUrl);

  return (
    <div className="bg-warm border-b border-warm-deep text-ink px-4 py-3 flex items-center justify-between gap-3 text-sm animate-slide-down">
      <span className="flex-1 leading-tight">
        Pour une meilleure expérience, ouvre dans Safari ou Chrome.
      </span>
      <a
        href={target}
        className="bg-primary text-white rounded-pill px-3 py-1.5 text-xs font-medium whitespace-nowrap shadow-warm-sm"
      >
        Ouvrir
      </a>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="text-ink/60 text-xs px-1"
        aria-label="Fermer"
      >
        ✕
      </button>
    </div>
  );
};
